import React from 'react';
import PageLayout from '../../component/PageLayout';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import bootstrapPlugin from '@fullcalendar/bootstrap';
// import { format } from 'date-fns';
import './style.css';
import IconRightArrow from '../../component/SvgIcons/IconRightArrow';
import { Link } from 'react-router-dom';


export default function Events() {
  return (
    <div className="home-main eventpage">
      <PageLayout>
        <div className='Innerpage-title'>
          <h1 className='title1 text-center box-default'>Events</h1>
        </div>
        <section className='pt50 calendar-main'>
          <div className='container'>
          <div className='calendarbox-main d-flex justify-content-between'>
           <div className='calendarleftside position-relative'>
            <div className='background'></div>
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, listPlugin, bootstrapPlugin]}
              headerToolbar={{
                left: 'prev,next',
                center: 'title',
                // right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                right:'today'
              }}      
            />
          </div>
          <div className='calendarrightside'>
           <h3>Events Details</h3>
           <div className='event-info'>
            <ul>
              <li><strong>Event Name</strong>: TallyPrime Release </li>
              <li><strong>Event Details</strong>: laceholder text commonly used to demonstrate the visual form of a document or a typeface </li>
              <li><strong>Event Time</strong>: 10:20 am </li>
            </ul>
            <Link className='btn btn-danger'>
            <label>Book Now <IconRightArrow/></label>
            <span></span>
            </Link>
            </div> 
          </div>
          </div>
          </div>
        </section>
      </PageLayout>
    </div>
  );
}
